import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Button, message, Popover, Radio, Spin, Tooltip } from "antd";
import styles from "./index.module.less";
import { DeleteIcon, EditIcon, HintIcon, ImageFilledIcon, PdfFilledIcon, PreviewIcon, WordFilledIcon, } from "@bossvn/icons";
import { GetUserResumes, SendAttachmentCv, sendChatResume, } from "@/services/resume";
import { parseFileName } from "@/utils/file";
import classNames from "classnames";
import ResumeUpload from "@/components/Resume/Upload";
import ResumePreview from "@/components/Resume/Preview";
import { useLocale } from "@/hooks/useLocale";
import DeleteModal from "@/common/AttachmentManager/deleteModal";
import RenameModal from "@/common/AttachmentManager/renameModal";
import CModal from "@/components/Modal";
import { withErrorBoundary } from "@/common/ErrorBoundary/hoc";
const ResumeList = withErrorBoundary(({ isOpen, close, bossId, bossHash, locale, successCallback, isQuickSend, jobId, }) => {
    const { t } = useLocale("attachmentResume", locale);
    // const { getUserResumeFiles, deleteUserResume } = UseApiHook();
    // const { sendCvN } = useChatHook();
    // const { peerId, peerHash } = useIM();
    const [fileInfo, setFileInfo] = useState(null);
    const [fileUrl, setFileUrl] = useState("");
    const [docPreviewName, setDocPreviewName] = useState("");
    const [showCvPreviewer, setShowCvPreviewer] = useState(false);
    //删除简历
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    //重命名简历
    const [showRenameModal, setShowRenameModal] = useState(false);
    //简历数据
    const [resumeData, setResumeData] = React.useState([]);
    //选中的简历
    const [selectedResume, setSelectedResume] = useState(null);
    //简历数据加载
    const [dataLoading, setDataLoading] = useState(false);
    //是否显示简历弹窗
    const [showUpload, setShowUpload] = useState(false);
    //发送简历加载
    const [loading, setLoading] = useState(false);
    //公开的简历
    const [openResume, setOpenResume] = useState(null);
    //未公开的简历
    const [notOpenResumes, setNotOpenResumes] = useState([]);
    //发送简历
    const sendResume = async () => {
        console.log(selectedResume, "奋斗奋斗");
        setLoading(true);
        let resp;
        if (isQuickSend) {
            resp = await sendChatResume({
                peer: { id: bossId, hash: bossHash },
                jobId: jobId,
            });
        }
        else {
            resp = await SendAttachmentCv({
                id: bossId,
                hash: bossHash,
                fileGroupId: selectedResume?.fileGroupId,
                force: true,
            });
        }
        if (resp?.code === 0) {
            closeModal();
            successCallback?.();
            message.success(t("sendCvSuccess"));
        }
        else {
            if (resp.code === 1001016) {
                message.warning(t("blockedTip"));
            }
            else {
                message.warning(t("sendCvFail"));
            }
        }
        setLoading(false);
    };
    //关闭窗口
    const closeModal = () => {
        close();
        setSelectedResume(null);
    };
    //获取附件简历
    const getResumeData = async () => {
        setDataLoading(true);
        const resp = await GetUserResumes();
        console.log("附件简历", resp);
        if (resp.code === 0) {
            let notOpenResumes = [];
            if (resp?.data?.list?.length === 0) {
                setOpenResume(null);
                setNotOpenResumes([]);
            }
            else {
                resp?.data?.list?.map((item) => {
                    if (item?.isOpen === 1) {
                        setOpenResume(item);
                    }
                    else {
                        notOpenResumes.push(item);
                    }
                });
            }
            setNotOpenResumes(notOpenResumes);
            setResumeData(() => resp.data.list);
            setSelectedResume(null);
            if (isQuickSend) {
                setSelectedResume(resp.data.list[0]);
            }
        }
        setDataLoading(false);
    };
    const renderResumeItem = (item) => {
        if (!item) {
            return _jsx(_Fragment, {});
        }
        let icon = (_jsx(PdfFilledIcon, { size: 32, primaryColor: "#FF2424", secondaryColor: "#fff" }));
        const { name, ext } = parseFileName(item?.files?.[0]?.fileName);
        if (ext === "doc" || ext === "docx") {
            icon = (_jsx(WordFilledIcon, { size: 32, primaryColor: "#577CF6", secondaryColor: "#fff" }));
        }
        else if (ext === "jpg" || ext === "png" || ext === "jpeg") {
            icon = (_jsx(ImageFilledIcon, { size: 32, primaryColor: "#577CF6", secondaryColor: "#fff" }));
        }
        return (_jsxs("div", { className: classNames(styles.resumeContent), onClick: () => {
                setSelectedResume(item);
            }, children: [_jsxs("div", { className: classNames(styles.resumeContentFileBox), onClick: () => { }, children: [_jsx(Radio, { checked: selectedResume?.fileGroupId === item?.fileGroupId }), icon, _jsxs("div", { className: classNames(styles.resumeContentFileBoxItem), children: [_jsx(Popover, { trigger: "hover", content: item.files?.[0]?.fileName, children: _jsx("span", { className: classNames(styles.resumeContentFileBoxItemName), children: item?.files?.[0]?.fileName }) }), _jsx("span", { className: classNames(styles.resumeContentFileBoxItemSize), children: showImageSize(item.files?.[0]) })] })] }), _jsxs("div", { className: classNames(styles.resumeContentOperateBox), children: [_jsx(PreviewIcon, { size: 20, primaryColor: "#333", secondaryColor: "#fff", onClick: (e) => {
                                e.stopPropagation();
                                void handleOperate("preview", item);
                            } }), _jsx(EditIcon, { size: 16, onClick: (e) => {
                                e.stopPropagation();
                                void handleOperate("edit", item);
                            } }), _jsx(DeleteIcon, { size: 20, onClick: (e) => {
                                e.stopPropagation();
                                void handleOperate("delete", item);
                            } })] })] }));
    };
    //显示文件大小
    const showImageSize = (file) => {
        const sizeInMB = file.size / 1024 / 1024;
        if (sizeInMB > 1) {
            return `${sizeInMB.toFixed(2)} MB`;
        }
        else {
            return `${(file.size / 1024).toFixed(2)} KB`;
        }
    };
    /**
     * 操作
     * @param type 操作类型
     * @param data 操作数据
     */
    const handleOperate = async (type, data) => {
        setSelectedResume(data);
        switch (type) {
            case "preview":
                setShowCvPreviewer(true);
                setFileInfo(data?.files);
                return;
            case "edit": {
                setShowRenameModal(true);
                return;
            }
            case "delete":
                setShowDeleteModal(true);
                return;
            default:
                return;
        }
    };
    useEffect(() => {
        if (isOpen) {
            void getResumeData();
            setSelectedResume(null);
        }
    }, [isOpen]);
    return (_jsxs(_Fragment, { children: [_jsxs(CModal, { open: isOpen, centered: true, onCancel: () => {
                    setSelectedResume(null);
                    close();
                }, title: _jsx("span", { style: { fontWeight: "700", color: "#333333" }, children: t("postCv") }), footer: _jsx("div", { children: _jsxs("div", { style: {
                            display: "flex",
                            gap: "18px",
                            justifyContent: "flex-end",
                        }, children: [_jsx(Button, { type: "default", className: classNames(styles.sendBtn), onClick: () => close(), children: t("cancel") }), _jsx(Button, { loading: loading, type: "primary", className: classNames(styles.sendBtn, styles.cvSendButton), disabled: !selectedResume, onClick: () => sendResume(), children: t("sendResume") })] }) }), children: [resumeData?.length === 0 && (_jsx("div", { className: styles.postCvTip, children: t("noCvTip") })), _jsxs(Spin, { spinning: dataLoading, size: "small", children: [openResume?.fileGroupId && (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.openResumeTip, children: [_jsx("span", { children: t("publicResumeDisplay") }), _jsx(Tooltip, { title: _jsx("div", { dangerouslySetInnerHTML: {
                                                        __html: t("openResumeTip"),
                                                    } }), children: _jsx(HintIcon, { primaryColor: "#F19D3E", size: 16 }) })] }), renderResumeItem(openResume)] })), notOpenResumes?.length > 0 && (_jsx("div", { className: styles.openResumeTip, children: t("otherResumes") })), notOpenResumes?.map((item, index) => renderResumeItem(item))] }), ((resumeData.length < 3 && !isQuickSend) ||
                        (isQuickSend && resumeData.length == 0)) &&
                        !dataLoading && (_jsx(_Fragment, { children: _jsx(Button, { className: "", type: "link", disabled: resumeData.length >= 3, color: "primary", style: { color: "#577CF6", padding: 0, fontWeight: 700 }, onClick: () => setShowUpload(true), children: t("uploadAttachmentResume") }) }))] }), _jsx(DeleteModal, { isDeleteModalOpen: showDeleteModal, setDeleteModalOpen: () => {
                    void getResumeData();
                    setShowDeleteModal(false);
                }, currentResume: selectedResume }), _jsx(RenameModal, { isRenameModalOpen: showRenameModal, setIsRenameModalOpen: () => {
                    void getResumeData();
                    setShowRenameModal(false);
                }, currentResume: selectedResume }), _jsx(ResumeUpload, { isOpen: showUpload, onClose: () => {
                    setShowUpload(false);
                }, refreshData: () => {
                    void getResumeData();
                }, locale: locale, type: 2 }), _jsx(ResumePreview, { isOpen: showCvPreviewer, linkFiles: fileInfo, showDownload: true, close: () => {
                    console.log("close");
                    setShowCvPreviewer(false);
                }, isLink: true, isChatMessage: false, isUpload: false, locale: locale })] }));
});
export default ResumeList;
